<p-panel>
    <ng-template pTemplate="header">
        <div><h4>{{title}}</h4></div>
        <div class="flex flex-auto justify-content-end gap-2">
            <p-button icon="pi pi-plus" label="New" [text]="true"  (onClick)="newFileOp.toggle($event)"></p-button>
            <p-overlayPanel appendTo="body" #newFileOp [style]="{width: '50vw', height:'60vh'}" styleClass="overflow-y-scroll">
                <p-fileUpload
                multiple
                maxFileSize="10000000" 
                customUpload
                accept=".jpg,.tiff,.zip,.pdf,.png"
                (uploadHandler)="uploadFiles($event)">
                    <ng-template pTemplate="empty">
                        <div class="flex align-items-center justify-content-center flex-column">
                            <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400"></i>
                            <p class="mt-4 mb-0">Drag and drop files to here to upload.</p>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="file"></ng-template>
                    <ng-template pTemplate="header" let-files let-uploadedFiles="uploadedFiles" let-chooseCallback="chooseCallback" let-clearCallback="clearCallback" let-uploadCallback="uploadCallback">
                        <p-button (click)="chooseCallback()" icon="pi pi-plus" label="Choose" iconPos="left"></p-button>
                        <p-button (click)="uploadCallback(); newFileOp.hide()" [disabled]="!filesReady(files)" icon="pi pi-upload" label="Upload" iconPos="left"></p-button>
                        <p-button (click)="clearCallback()" icon="pi pi-times" label="Cancel" iconPos="left"></p-button>

                    </ng-template>

                    <ng-template pTemplate="content" let-files let-uploadedFiles="uploadedFiles" let-removeFileCallback="removeFileCallback" let-removeUploadedFileCallback="removeUploadedFileCallback">
                        <div *ngFor="let f of files; index as i" class="flex flex-row mt-5 w-full">
                            <div *ngIf="isImage(f)" class="flex ml-2 mr-2 align-items-center"><img  [src]="f.objectURL" width="50" height="auto"/></div>
                            <div *ngIf="isPdf(f)" class="flex ml-2 mr-2 align-items-center justify-content-center"><i class="pi pi-file-pdf" style="font-size: 2rem; width:50px"></i></div>
                            <div *ngIf="isZip(f)" class="flex ml-2 mr-2 align-items-center justify-content-center"><i class="pi pi-box" style="font-size: 2rem; width:50px"></i></div>

                            <div class="flex ml-2 mr-2">
                                <p-floatLabel>
                                    <input id="name" type="text" pInputText [(ngModel)]="f.name"/>
                                    <label for="name">Name</label>
                                </p-floatLabel>
                            </div>
                            <div class="flex ml-2 mr-2">
                                <p-floatLabel>
                                    <p-dropdown id="category" [(ngModel)]="f.category" [options]="uploadCategories"></p-dropdown>
                                    <label for="category">Category</label>
                                </p-floatLabel>
                            </div>
                            <div class="flex ml-2 mr-2">
                                <p-floatLabel>
                                    <input type="text" pInputText id="fileType" [disabled]="true" [ngModel]="getFileType(f)"/>
                                    <label for="fileType">File Type</label>
                                </p-floatLabel>
                            </div>
                            <div class="flex ml-2 mr-2 justify-content-end flex-auto">
                                <p-button icon="pi pi-times" text (click)="removeFileCallback()"></p-button>
                            </div>
                        </div>
                    </ng-template>
                </p-fileUpload>

            </p-overlayPanel>
        </div>
    </ng-template>
    <div class="flex flex-column overflow-y-scroll">

        <p-table [value]="sortedFiles" [paginator]="sortedFiles.length > 5" [rows]="5">
           
            <ng-template pTemplate="header">
                <tr>
                    <th>File Name</th>
                    <th>Category</th>
                    <th>Type</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-file>
                <tr>
                    <td>
                        {{file.fileName}}
                    </td>
                    <td>
                        {{file.fileCategory}}
                    </td>
                    <td>
                        {{file.fileType}}
                    </td>
                    <td>
                        <p-button icon="pi pi-download" label="Download" [text]="true"  (onClick)="viewAttachment(file)"></p-button>
                        <p-button icon="pi pi-trash" label="Delete" [text]="true"  (onClick)="deleteFile(file)"></p-button>
                    </td>
                </tr>
            </ng-template>

        </p-table>


        
    
    </div>
</p-panel>
